import { render, staticRenderFns } from "./TheSourcePagination.vue?vue&type=template&id=4d13980a&scoped=true&"
import script from "./TheSourcePagination.vue?vue&type=script&lang=js&"
export * from "./TheSourcePagination.vue?vue&type=script&lang=js&"
import style0 from "./TheSourcePagination.vue?vue&type=style&index=0&id=4d13980a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13980a",
  null
  
)

export default component.exports